import { render, staticRenderFns } from "./AudioPage.vue?vue&type=template&id=13be2dc4&scoped=true&"
import script from "./AudioPage.vue?vue&type=script&lang=js&"
export * from "./AudioPage.vue?vue&type=script&lang=js&"
import style0 from "./AudioPage.vue?vue&type=style&index=0&id=13be2dc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13be2dc4",
  null
  
)

export default component.exports